import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'

function useBuilderQuestion(questionId: string) {
  const { getQuestion } = React.useContext(FormBuilderContext)

  const [question, setQuestion] = React.useState(getQuestion(questionId))

  React.useEffect(() => {
    setQuestion(getQuestion(questionId))
  }, [questionId, getQuestion])

  return question
}

export default useBuilderQuestion
